import { useShallow } from 'zustand/react/shallow';

import { defectTimeSorter } from '@/domain/defecten/defectSorter';
import useClientState from '@/state/useClientState';
import { DefectSoort } from '@/types/Defecten';
import { endOfTomorrow2AM } from '@/utils/dateUtils';

const defaultOptions = {
  geefAlleenDefectenTerugTotEindeBijsturingsPeriode: false,
  geefAlleenNietGereedGemeldeDecten: false,
  sorteerOpTijd: false,
};

/**
 * Custom hook voor het consumeren van defecten.
 * Filters zijn optioneel, zonder filters worden alle defecten teruggegeven.
 */
const useDefecten = (
  eenheidNummer: (string | undefined)[] | null = null,
  defectSoorten: DefectSoort[] | null = null,
  options: {
    geefAlleenDefectenTerugTotEindeBijsturingsPeriode: boolean;
    geefAlleenNietGereedGemeldeDecten: boolean;
    sorteerOpTijd: boolean;
  } = defaultOptions,
) => {
  const defectenView = useClientState(
    useShallow((state) => {
      let resultaat = state.defecten;
      if (eenheidNummer) {
        resultaat = resultaat.filter((d) => eenheidNummer.includes(d.eenheidNummer));
      }
      if (defectSoorten) {
        resultaat = resultaat.filter((d) => defectSoorten.includes(d.soort));
      }
      if (options.geefAlleenDefectenTerugTotEindeBijsturingsPeriode) {
        const lastDayOfViewAt2AM = endOfTomorrow2AM(new Date());
        resultaat = resultaat.filter((d) => {
          const beginTijd = new Date(d.beginTijd as string).getTime();
          return beginTijd <= lastDayOfViewAt2AM.getTime();
        });
      }
      if (options.geefAlleenNietGereedGemeldeDecten) {
        resultaat = resultaat.filter((d) => !d.gereedgemeld);
      }
      if (options.sorteerOpTijd) resultaat.sort(defectTimeSorter);
      return resultaat;
    }),
  );
  return { defectenView };
};
export default useDefecten;
